import React from 'react';
import AnswerCard from '../AnswerCard';
import AnswerType from '../AnswerType';
import { injectIntl } from 'react-intl';


function AnswerSingle(props) {
	const { answers, onOptionsChanged, questionId, questions, value, messages, intl: { formatMessage } } = props;
	if ((!questionId && questionId !== 0) || !questions) return null;
	const question = questions[questionId];
	const questionTitle = `survey.question.${questionId}`;
	const answerId = question.answers[0];
	const answerTitle = `survey.answers.${answerId}`;
	return <AnswerCard title={formatMessage(messages[questionTitle])} className='SingleVariant' {...props}>
		<AnswerType
			className={'Variant'}
            value={value}
			type={answers[answerId].type}
            title={formatMessage(messages[answerTitle])}
            onChange={onOptionsChanged}
		/>
	</AnswerCard>;
}

export default injectIntl(AnswerSingle);


// WEBPACK FOOTER //
// ./src/components/AnswerSingle/AnswerSingle.js